export const ACCESS_TYPES = {
  LICENSED: "LICENSED",
  MRV: "MRV",
  REALGEMS_USER: "REALGEMS_USER",
  REALGEMS_ADMIN: "REALGEMS_ADMIN",
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
};

export const normalizeAccessType = (value) => {
  const normalized = String(value || "")
    .trim()
    .toUpperCase();

  return ACCESS_TYPES[normalized] || normalized;
};

export const isLicensed = (role) => normalizeAccessType(role) === ACCESS_TYPES.LICENSED;

export const isAdmin = (role) => normalizeAccessType(role) === ACCESS_TYPES.ADMIN;

export const isSuperAdmin = (role) => normalizeAccessType(role) === ACCESS_TYPES.SUPER_ADMIN;

export const isRealgemsUser = (role) => normalizeAccessType(role) === ACCESS_TYPES.REALGEMS_USER;

export const isRealgemsAdmin = (role) => normalizeAccessType(role) === ACCESS_TYPES.REALGEMS_ADMIN;

export const canAccessRealgemsArea = (role) => {
  const normalized = normalizeAccessType(role);
  return (
    normalized === ACCESS_TYPES.REALGEMS_ADMIN ||
    normalized === ACCESS_TYPES.REALGEMS_USER
  );
};

export const canAccessAdminArea = (role) => {
  const normalized = normalizeAccessType(role);
  return normalized === ACCESS_TYPES.ADMIN || normalized === ACCESS_TYPES.SUPER_ADMIN;
};

export const canAccessAllowedRole = (userRole, allowed = []) => {
  const normalizedUserRole = normalizeAccessType(userRole);
  const normalizedAllowedRoles = allowed.map(normalizeAccessType).filter(Boolean);

  if (!normalizedUserRole || normalizedAllowedRoles.length === 0) return false;
  if (normalizedAllowedRoles.includes(normalizedUserRole)) return true;

  if (
    normalizedUserRole === ACCESS_TYPES.SUPER_ADMIN &&
    normalizedAllowedRoles.includes(ACCESS_TYPES.ADMIN)
  ) {
    return true;
  }

  if (
    normalizedUserRole === ACCESS_TYPES.REALGEMS_ADMIN &&
    normalizedAllowedRoles.includes(ACCESS_TYPES.REALGEMS_USER)
  ) {
    return true;
  }

  return false;
};

export const getHomeRouteForRole = (role) => {
  if (canAccessAdminArea(role)) return "/admin/dashboard";
  if (canAccessRealgemsArea(role)) return "/realgems/dashboard";
  if (normalizeAccessType(role) === ACCESS_TYPES.MRV) return "/mrv/dashboard";
  if (isLicensed(role)) return "/dashboard";
  return "/";
};

export const getLoginRouteForRole = (role) =>
  normalizeAccessType(role) === ACCESS_TYPES.MRV ? "/mrv" : canAccessRealgemsArea(role) ? "/realgems" : "/";

export const getCreatableAccessTypes = (role) => {
  if (isSuperAdmin(role)) {
    return [
      { label: "Usuario licenciado", value: ACCESS_TYPES.LICENSED },
      { label: "MRV", value: ACCESS_TYPES.MRV },
      { label: "Usuario Realgems", value: ACCESS_TYPES.REALGEMS_USER },
      { label: "Administrador Realgems", value: ACCESS_TYPES.REALGEMS_ADMIN },
      { label: "Administrador", value: ACCESS_TYPES.ADMIN },
      { label: "Super administrador", value: ACCESS_TYPES.SUPER_ADMIN },
    ];
  }

  if (isAdmin(role)) {
    return [
      { label: "Usuario licenciado", value: ACCESS_TYPES.LICENSED },
      { label: "MRV", value: ACCESS_TYPES.MRV },
      { label: "Usuario Realgems", value: ACCESS_TYPES.REALGEMS_USER },
      { label: "Administrador Realgems", value: ACCESS_TYPES.REALGEMS_ADMIN },
    ];
  }

  return [];
};

export const canManageUserRole = (actorRole, targetRole) => {
  const normalizedActorRole = normalizeAccessType(actorRole);
  const normalizedTargetRole = normalizeAccessType(targetRole);

  if (normalizedActorRole === ACCESS_TYPES.SUPER_ADMIN) {
    return Object.values(ACCESS_TYPES).includes(normalizedTargetRole);
  }

  if (normalizedActorRole === ACCESS_TYPES.ADMIN) {
    return [
      ACCESS_TYPES.LICENSED,
      ACCESS_TYPES.MRV,
      ACCESS_TYPES.REALGEMS_ADMIN,
      ACCESS_TYPES.REALGEMS_USER,
    ].includes(normalizedTargetRole);
  }

  return false;
};

export const getAccessTypeLabel = (role) => {
  switch (normalizeAccessType(role)) {
    case ACCESS_TYPES.SUPER_ADMIN:
      return "Super administrador";
    case ACCESS_TYPES.ADMIN:
      return "Administrador";
    case ACCESS_TYPES.REALGEMS_ADMIN:
      return "Administrador Realgems";
    case ACCESS_TYPES.REALGEMS_USER:
      return "Usuario Realgems";
    case ACCESS_TYPES.MRV:
      return "MRV";
    case ACCESS_TYPES.LICENSED:
      return "Licenciado";
    default:
      return "Nao informado";
  }
};
